module.exports = __webpack_public_path__ + "static/img/icono-user.aa75fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-user.png
// module id = 9Mjp
// module chunks = 3